// wrappers for segment functions
import store from 'store/index';
import { getCurrentUser } from 'selectors';
import { DEFAULT_PROPERTIES, EVENT_NAMES } from 'analytics/constants';
import getPortalTaskFromPath from 'analytics/helpers';
import { CUSTOMER_PORTAL } from './constants';

const dialog = (popupName, options, callback) => {
  const state = store.getState();
  const { id } = getCurrentUser(state);
  window.analytics.track(EVENT_NAMES.DIALOG, {
    name: popupName,
    [DEFAULT_PROPERTIES.USER_ID]: id,
    surface: CUSTOMER_PORTAL
  }, options, callback);
  return 'string called';
};

export const dialogWithProps = (popupName, options, callback) => (props) => {
  const state = store.getState();
  const { id, customer } = getCurrentUser(state);
  const category = getPortalTaskFromPath(document.location.pathname);
  const params = {
    category,
    name: popupName,
    [DEFAULT_PROPERTIES.USER_ID]: id,
    [DEFAULT_PROPERTIES.CUSTOMER_ID]: customer.id,
    surface: CUSTOMER_PORTAL,
    ...props
  };
  window.analytics.track(EVENT_NAMES.DIALOG, params, options, callback);
  return 'string called';
};

export default dialog;
